import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FormModal } from '../../Form'

import { FormFields } from './FormFields'
import {
  QA_NAME_REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL,
  REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_DEFAULT_OPTION,
  REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_RECIPIENTS_FIELD_NAME,
} from './RequestProfileEmailAudienceModal.constants'

function RequestProfileEmailAudienceModal({ onClose, onSubmit }) {
  const { t } = useTranslation()

  const initialValues = useMemo(
    () => ({
      [REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_RECIPIENTS_FIELD_NAME]: {
        ...REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_DEFAULT_OPTION,
        label: t(REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_DEFAULT_OPTION.label),
      },
    }),
    []
  )

  function handleSubmit({ values }) {
    onSubmit({
      recipientType:
        values[REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL_RECIPIENTS_FIELD_NAME]
          .value,
    })
  }

  return (
    <FormModal
      Fields={FormFields}
      formTitle='RequestProfile.EmailAudienceModalTitleKey'
      initialValues={initialValues}
      qaName={QA_NAME_REQUEST_PROFILE_EMAIL_AUDIENCE_MODAL}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestProfileEmailAudienceModal
